import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Table, Alert, Spinner } from "react-bootstrap";

const OrdersOverview = ({ startDate, endDate }) => {
  const [analytics, setAnalytics] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    if (!startDate || !endDate) return;
    const fetchAnalytics = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetch(
          `${apiUrl}/admin/analytics/orders-overview?start_date=${startDate}&end_date=${endDate}`,
          {
            credentials: "include",
          }
        );
        if (!response.ok) {
          throw new Error("Ошибка загрузки данных");
        }
        const data = await response.json();
        setAnalytics(data);
      } catch (error) {
        console.error("Ошибка загрузки данных:", error);
        setError("Не удалось загрузить данные.");
      } finally {
        setLoading(false);
      }
    };
    fetchAnalytics();
  }, [apiUrl, startDate, endDate]);

  return (
    <div>
      <div className="d-flex justify-content-between align-items-baseline mb-3">
        <h3 className="mb-0">Топ лидеров продаж по количеству</h3>
        <p className="text-muted small mb-0">
          Период: {startDate} — {endDate}
        </p>
      </div>

      {loading ? (
        <div className="text-center">
          <Spinner animation="border" />
          <p>Загрузка…</p>
        </div>
      ) : error ? (
        <Alert variant="danger">{error}</Alert>
      ) : analytics && analytics.top_partners?.length ? (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>#</th>
              <th>Партнёр</th>
              <th>Количество заказов</th>
            </tr>
          </thead>
          <tbody>
            {analytics.top_partners.map((partner, index) => (
              <tr key={partner.partner_name}>
                <td>{index + 1}</td>
                <td>{partner.partner_name}</td>
                <td>{partner.order_count}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <Alert variant="info" className="mb-0">
          Нет данных для выбранного диапазона.
        </Alert>
      )}
    </div>
  );
};

export default OrdersOverview;
OrdersOverview.propTypes = {
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
};
